// extracted by mini-css-extract-plugin
export default {"container":"DriverLayout_container__ByQZZ","wrapper":"DriverLayout_wrapper__8l1uw"};